import React, {
  memo, useCallback, useContext, useEffect, useMemo, useState,
} from 'react';
import { Link } from 'react-router-dom';
import {
  Alert,
  AlertTitle, Avatar,
  Box, Button,
  Card,
  CardHeader, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  Grid,
  IconButton,
  Paper,
  Typography,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import { faFileLines } from '@fortawesome/free-solid-svg-icons';
import SearchInput from '../../components/MaterialUI/searchInput';
import api from '../../api/req';
import { AppContext } from '../../providers/authProvider';
import Loader from '../../components/MaterialUI/loader';

function ReportLister() {
  const { auth } = useContext(AppContext);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);
  const [reportList, setReportList] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [delReportId, setDelReportId] = useState(null);

  const reload = useCallback(
    () => {
      const loader = async () => {
        const r = await api.get('/api/reports/report/', auth);
        if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
        return r.json();
      };
      setLoading(true);
      setErr(null);
      loader()
        .then((d) => setReportList(d))
        .catch((e) => setErr(e.message))
        .finally(() => setLoading(false));
    },
    [auth],
  );
  useEffect(() => reload(), [reload]);
  const searchedReportList = useMemo(
    () => {
      if (!searchText) return reportList;
      return reportList.filter((r) => `${r.title}${r.description}`.toUpperCase()
        .indexOf(searchText.toUpperCase()) !== -1);
    },
    [reportList, searchText],
  );
  const onDeleteReport = useCallback(
    (reportId) => {
      const loader = async () => {
        const r = await api.delete(`/api/reports/report/${reportId}/`, auth);
        if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
        return true;
      };
      setLoading(true);
      setErr(null);
      loader()
        .then(() => reload())
        .catch((e) => setErr(e.message))
        .finally(() => setLoading(false));
    },
    [auth, reload],
  );
  return (
    <>
      <Box overflow="auto" id="aaaa" height="100%">
        {loading && (
        <Loader text="Завантаження" />
        )}
        <Box display="flex" justifyContent="space-between" position="sticky" top="0" sx={{ bgcolor: 'grey.100', zIndex: 2, paddingBottom: 1 }}>
          <Typography variant="h5" color="primary">Звітність</Typography>
          <Box width="min(30rem, 50%)">
            <SearchInput
              onChange={(e, v) => setSearchText(v)}
              value={searchText}
            />
          </Box>
        </Box>
        {err && (
        <Alert severity="error" onClose={reload}>
          <AlertTitle>
            {err}
          </AlertTitle>
        </Alert>
        )}
        <Paper sx={{
          padding: 3,
          marginTop: 2,
        }}
        >
          <Grid container>
            {searchedReportList.length ? searchedReportList.map((r) => (
              <Grid item md={3} key={r.id} display="flex">
                <Card sx={{ margin: 1, flex: '1 1 auto' }}>
                  <CardHeader
                    avatar={(
                      <Link to={`/grep/${r.id}`}>
                        <Avatar sx={{ bgcolor: '#4272d7' }}>
                          <FontAwesomeIcon icon={faFileLines} />
                        </Avatar>
                      </Link>
                  )}
                    action={(
                      <IconButton onClick={() => setDelReportId(r.id)} size="small" color="error">
                        <FontAwesomeIcon icon={faTrashAlt} />
                      </IconButton>
                  )}
                    title={<Link to={`/grep/${r.id}`}>{r.name }</Link>}
                    subheader={r.description}
                  />
                </Card>
              </Grid>
            )) : (
              <Alert severity="info" sx={{ width: '100%' }}>
                <AlertTitle>Немає звітів</AlertTitle>
                За заданими умовами пошуку немає жодного звіту
              </Alert>
            )}
          </Grid>
        </Paper>
      </Box>
      <Dialog
        open={!!delReportId}
        onClose={() => setDelReportId(null)}
      >
        <DialogTitle>
          Видалення звіту
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Ця операція не зворотня. Ви дійсно бажаєте видалити обраний звіт?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => onDeleteReport(delReportId)} color="error">Так</Button>
          <Button onClick={() => setDelReportId(null)} autoFocus color="success">
            Ні
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default memo(ReportLister);
